import axios from 'axios';


const apiUrl = 'https://rvsm-artigo.dev.ml.grupoiagsaude.com.br';

/*
const apiUrl = 'http://127.0.0.1:5000/invocations';
*/
const fazerSolicitacaoPost = async (postData) => {
  try {
    const response = await axios.post(apiUrl, postData, {
      headers: {
        'authorizationToken': 'allow',
        'Content-Type': 'application/json',
        'x-api-key': 'ec88E9u86AofPa3mdosj2RuIpsoPW912aZOUy6Yj',
        'Access-Control-Allow-Origin': '*',
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export { fazerSolicitacaoPost }
